import React from 'react'
// import Navbar from '../inc/Navbar'
import Slider from '../inc/Slider'
import About from './About'

import "./Home.css";
import NoticeBoard from './NoticeBoard';
import EventHeld from './EventHeld';
import ScrollToTop from "react-scroll-to-top";
import FacilitySlider from './FacilitySlider';
import SlideButton from './SlideButton';
import Course from './Course';
import SearchApplication from './SeachApplication';

import Navbar from '../inc/Navbar';

function Home() {
  return (
    <div>
      <Navbar/>
      <br />
      <br />
      <br />
      <br />
      <Slider />
   
       <div className='computereducation'>
                <div className="album py-0">
                    <div className="container">
                        <marquee>
                            <h5 style={{ margin: "2px", }} className='mt-2'>An <b className='kpsfonts'>  </b>  ISO 9001: 2015 Certified Organization | ISO Certificate No: 230422083580QRA </h5>
                        </marquee>
                    </div>
                </div>
            </div>
            <br/>
      <About />
      <div className='applynew'>
        <br/>
       <div className="album py-0">
        <div className="container">
            <div className="row">
            <div className="col-md-7">
 <h1>Print <b style={{color:"#fff1f2"}}> Teacher Application Form</b></h1>
          <hr  style={{color:"#fff1f2"}}/>
          <h6 style={{color:"#fff1f2"}}><b>Recruitment Process:</b></h6>
<p style={{color:"#fff1f2"}} className='mb-2'> 1️⃣ Online Examination | 2️⃣ District-wise Intervie | 3️⃣ Final Selection</p>

               <a href='TeacherForm'>
           <p><button className='apply mt-1'>New Apply </button></p>
           </a>
      
            </div>
         
          </div>
          </div>
          
        </div>

      <SearchApplication/>
      <br/>
      </div>
      <br/>
 <div className="album py-0">
        <div className="container">
            <div className="row">
            <div className="col-md-3 ">
 <h1>Our <b style={{color:"#ED1B24"}}> Facilities</b></h1>
          <hr/>
          
            </div>
         
          </div>
          </div>
          <br/>
        </div>
      <FacilitySlider/>
      <SlideButton/>
      
                     <ScrollToTop smooth top="100" color="marroon" />

   
      <div className="course">
           <br />
        
      <Course/>
      <br/>
      </div>
      <br/>

         <div className="album py-0">
                <div className="container">
                    <div className="row">





                        <div className="col-md-6 mt-3">
                            <div className='cardmotation'>
                                <div className="card">
                                    <h4 className='btn-grad84'>NOTICE BOARD <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" fill="currentColor" class="bi bi-clipboard" viewBox="0 0 16 16">
                                        <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1z" />
                                        <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0z" />
                                    </svg> </h4>

                                    <div className="card-body ">

                                        <div className='welcometext'>
                                            <br />
                                            <NoticeBoard/>


                                            <br />
                                            <br />
                                            <br />

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>





                        <div className="col-md-6 mt-3">
                            <div className='cardmotation'>
                                <div className="card">
                                    <h4 className='btn-grad88'>UPCOMING EVENT HELD <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" fill="currentColor" class="bi bi-calendar-event-fill" viewBox="0 0 16 16">
                                        <path d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2m-3.5-7h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5" />
                                    </svg></h4>
                                    <div className="card-body">
                                        <div className='welcometext'>

                                            <br />
                                            <EventHeld />


                                            <br />
                                            <br />
                                            <br />




                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <br/>


    </div>
  )
}

export default Home